import { useIntl } from '@zenbusiness/application-commons-intl';
import BasicBreadcrumbs from '@zenbusiness/zui/BasicBreadcrumbs';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

export const LOCALIZED_TEXT = {
  dashboard: 'route.dashboard.label',
  businessProfile: 'route.businessProfile.label',
};

function Breadcrumbs() {
  const dashboardPath = useDashboardPath();
  const { formatMessage: fm } = useIntl();

  return (
    <BasicBreadcrumbs
      items={[
        {
          label: fm({ id: LOCALIZED_TEXT.dashboard }),
          to: dashboardPath,
        },
        { label: fm({ id: LOCALIZED_TEXT.businessProfile }) },
      ]}
    />
  );
}

export default Breadcrumbs;
